angular.module('routes.users.UsersPayloadResolver', [
  'stack'
])

/**
 * The UsersPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class UsersPayloadResolver
 * @constructor
 * @module routes.users.UsersPayloadResolver
 */
.factory('UsersPayloadResolver', [
  '$q',
  'GLOBAL',
  'ModelsService',
  function ($q, GLOBAL, ModelsService) {
    'use strict';

    return function (params) {
      var queue = [];

      if (!params.userId) {
        queue.push(ModelsService.initialize('users', GLOBAL.apiPath + '/users'));
      } else {
        queue.push(ModelsService.get('users', GLOBAL.apiPath + '/users', { id: params.userId }));
      }

      return $q
        .all(queue)
        .then(function () {
          return {};
        });
    };
  }
]);
